import { render, staticRenderFns } from "./PurchaseAndSaleTabItem.vue?vue&type=template&id=286096a6&scoped=true&"
import script from "./PurchaseAndSaleTabItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseAndSaleTabItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseAndSaleTabItem.vue?vue&type=style&index=0&id=286096a6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286096a6",
  null
  
)

export default component.exports